"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickProductSource = void 0;
let ClickProductSource = exports.ClickProductSource = /*#__PURE__*/function (ClickProductSource) {
  /** If source is `productCard` then it means that user clicked in the areas of the product card in the grid recommended product page. The area is the same as the area that by default will open the expanded product card(product detail modal). */
  ClickProductSource["productCard"] = "productCard";
  /** If source is productList then it means that user clicked on a button in the product card that redirects user to another url(moreInfo action). */
  ClickProductSource["productList"] = "productList";
  /** If source is `expandedProductCard` then it means that user clicked on a button in the expanded product card(product detail modal) that redirects user to another url(moreInfo action in modal). */
  ClickProductSource["expandedProductCard"] = "expandedProductCard";
  /** `other` is the default source and any callbacks from other places will have it as the source. */
  ClickProductSource["other"] = "other";
  return ClickProductSource;
}({});